import { genComponentStyleHook } from '../geek/styleUtil'
import { genStyle } from './checkboxStyle'

export default genComponentStyleHook(['Radio', 'heroTheme'], (token) => {
  return [genStyle(token as any)]
})
